

import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { listadoUnidadesMedida } from "../../../services";




export const useTodasUnidadesMedida = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['unidadesMedida-todos', { page, termino }], 
        queryFn: () => listadoUnidadesMedida({ page, termino }),
    });

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])


    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}